import { hasOwnProperty, isObject } from "@next-core/utils/general";
import { asyncComputeRealValue, computeRealValue } from "./computeRealValue.js";
import { isPreEvaluated } from "./evaluate.js";
import { resolveData } from "../data/resolveData.js";
import { getV2RuntimeFromDll } from "../../getV2RuntimeFromDll.js";

/**
 * 包含 `if` 条件判断的对象。
 */

export async function asyncCheckIf(ifContainer, runtimeContext) {
  return !hasOwnProperty(ifContainer, "if") || !!(typeof ifContainer.if === "string" || isPreEvaluated(ifContainer.if) ? await asyncComputeRealValue(ifContainer.if, runtimeContext) : ifContainer.if);
}
export function checkIf(ifContainer, runtimeContext) {
  return !hasOwnProperty(ifContainer, "if") || !!(typeof ifContainer.if === "string" || isPreEvaluated(ifContainer.if) ? computeRealValue(ifContainer.if, runtimeContext) : ifContainer.if);
}
export function checkIfOfComputed(ifContainer) {
  return !hasOwnProperty(ifContainer, "if") || !!ifContainer.if;
}
export async function asyncCheckBrickIf(brickConf, runtimeContext) {
  if (isObject(brickConf.if) && !isPreEvaluated(brickConf.if)) {
    const resolved = await resolveData(brickConf.if, runtimeContext);
    return checkIfOfComputed(resolved);
  }
  return asyncCheckIf(brickConf, runtimeContext);
}
function checkIfByTransformV3(ifContainer, data) {
  return checkIf(ifContainer, {
    data
  });
}

// istanbul ignore next
function checkIfByTransformV2Factory() {
  const v2Kit = getV2RuntimeFromDll();
  if (v2Kit) {
    return v2Kit.looseCheckIfByTransform;
  }
}

// istanbul ignore next
export const checkIfByTransform = checkIfByTransformV2Factory() || checkIfByTransformV3;
//# sourceMappingURL=checkIf.js.map